/**
 * Created by adnan on 4/9/15.
 */
export default {
    GET: '__GET__',
    POST: '__POST__',
    DELETE: '__DELETE__',
    PATCH: '__PATCH__',
    NAVIGATED_TO_PAGE: '__NAVIGATED_TO_PAGE__',
};
